import React from 'react';
import './DispatchBoard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCancel, faUsersSlash } from '@fortawesome/free-solid-svg-icons';
import {
    Button,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { Weekdays } from '../Common';

export default class RemoveAssignmentsButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCancelModal: false,
        };
    }

    shouldShowCancel = () => {
        const { job, dayInt } = this.props;

        return Boolean(
            job &&
            job.assignments &&
            job.assignments[dayInt].canEdit &&
            Boolean(
                job.assignments[dayInt].staff.length ||
                job.assignments[dayInt].equipment.length
            )
        );
    };

    toggleCancelModal = () => {
        const { showCancelModal } = this.state;

        this.setState({
            showCancelModal: !showCancelModal,
        });
    };

    onClearAssignmentsClick = () => {
        const { job, dayInt, onRemoveDayJob } = this.props;

        this.setState({ showCancelModal: false }, () =>
            onRemoveDayJob(job, dayInt)
        );
    };

    render() {
        const { showCancelModal } = this.state;
        const { job, dayInt } = this.props;

        const cancelWeekday = Weekdays.find((wd) => wd.id == dayInt) ?? {};

        const showCancel = this.shouldShowCancel();

        if (!showCancel) {
            return null;
        }

        return (
            <>
                <span
                    title="Remove all assignments for this job"
                    className="text-danger cursor-pointer ml-2 remove-assignments-button"
                    onClick={this.toggleCancelModal}
                >
                    Cancel
                </span>
                <Modal
                    size="lg"
                    fade={false}
                    isOpen={showCancelModal}
                    toggle={this.toggleCancelModal}
                >
                    <ModalHeader toggle={this.toggleCancelModal}>
                        Removing Assignments
                    </ModalHeader>
                    <ModalBody>
                        {job.longTermScheduleId && (
                            <div className="mb-2">
                                To cancel this assignment, please use the
                                long-term schedule calendar.
                            </div>
                        )}
                        Continuing will first remove all assigned personnel and
                        equipment for {cancelWeekday.name}'s {job.name} order,
                        with foreman {job.foremanName}. Are you sure?
                    </ModalBody>
                    <ModalFooter className="d-flex">
                        <Col size={6}>
                            <Button
                                type="button"
                                color="warning"
                                outline
                                onClick={this.toggleCancelModal}
                            >
                                <FontAwesomeIcon
                                    icon={faCancel}
                                    className="mr-1"
                                />
                                Cancel
                            </Button>
                        </Col>
                        <Col size={6} className="text-right">
                            <Button
                                type="button"
                                color="success"
                                onClick={this.onClearAssignmentsClick}
                            >
                                <FontAwesomeIcon
                                    icon={faUsersSlash}
                                    className="mr-1"
                                />
                                Clear Assignments
                            </Button>
                        </Col>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
